"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var RangeSelectCard_1 = require("./component/RangeSelectCard");
var CommonStatCard_1 = require("./component/CommonStatCard");
var ByBrandStatCard_1 = require("./component/ByBrandStatCard");
var PDashBoard = /** @class */ (function (_super) {
    __extends(PDashBoard, _super);
    function PDashBoard(props) {
        return _super.call(this, props) || this;
    }
    PDashBoard.prototype.render = function () {
        return (React.createElement("div", { style: {
                minHeight: "calc( 100vh - " + this.props.state.UIHeaderHeightPx + "px )",
                width: "100%",
                flexDirection: "column",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start"
            } },
            React.createElement(RangeSelectCard_1.default, { data: this.props.data, state: this.props.state }),
            React.createElement(CommonStatCard_1.default, { data: this.props.data, state: this.props.state }),
            React.createElement(ByBrandStatCard_1.default, { data: this.props.data, state: this.props.state })));
    };
    PDashBoard.getPageDescription = function (state) {
        return {
            icon: "tachometer-alt",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_main_dashboard + "-id",
            itemTitle: "Дашборд",
            route: routes_1.routes.page_main_dashboard,
            docType: UiStateController_1.UIDocumentType.udtMainPage
        };
    };
    return PDashBoard;
}(React.Component));
exports.default = PDashBoard;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_dashboard/ui/PDashBoard.tsx
// module id = 767
// module chunks = 0